import PropTypes from "prop-types";

const VARIANTS = ["secondary", "outline", "danger", "white"];
const SIZES = ["big"];

const Button = ({
  children = null,
  className,
  href,
  loading = false,
  onClick = () => {},
  size = null,
  variant,
  type = "button",
  ...rest
}) => {
  let btnClass = "qpp-c-button";

  if (VARIANTS.includes(variant)) {
    btnClass = btnClass.concat(" ", `qpp-c-button--${variant}`);
  }
  if (SIZES.includes(size)) {
    btnClass = btnClass.concat(" ", `qpp-c-button--${size}`);
  }
  if (className) {
    btnClass = btnClass.concat(" ", className);
  }

  if (href) {
    return (
      <a
        href={href}
        data-testid="ds-btn"
        className={btnClass || ""}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }
  return (
    <button
      data-testid="ds-btn"
      className={btnClass || ""}
      onClick={onClick}
      disabled={loading}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(SIZES),
  type: PropTypes.string,
  variant: PropTypes.oneOf(VARIANTS),
};

export const TextButton = ({ className = "", ...props }) => (
  <Button className={`qpp-c-button--text ${className}`} {...props} />
);

TextButton.propTypes = {
  className: PropTypes.string,
};

export default Button;
